import { useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import { send } from "@utils/ubcLogger/send";
import { UbcSendOptions } from "@typing/ubc/ubcLog.interface";
import { formatCurrentTime, getLocation } from "@utils/util";

/**
 * 封装埋点 hook
 *
 * 解决问题：window.location.pathname 包含动态 sessionId，
 * 导致每个用户的 page 字段都不同，不利于埋点数据聚合查询。
 *
 * 将动态参数剔除
 */
export function useUbcSend() {
    const location = useLocation();
    const params = useParams();

    const getRouteBase = () => {
        let path = location.pathname;
        // 把所有动态参数值替换掉
        Object.values(params).forEach((value) => {
            if (value) {
                path = path.replace(`/${value}`, "");
            }
        });

        return path;
    };

    /**
     * 发送埋点（自动规范化 page 路径）
     */
    const ubcSend = useCallback((options: UbcSendOptions) => {
        const { fullPath } = getLocation();
        const { ext, page, ...restOptions } = options;
        const path = getRouteBase();
        const normalizedPage = page ?? `${window.location.origin}${path}`;
        const globalTime = formatCurrentTime();
        const productInfo = {
            ...ext?.product_info,
            globalTime,
        }

        send({
            ...restOptions,
            page: normalizedPage,
            ext: {
                ...ext,
                route: {
                    path: normalizedPage,
                    fullPath,
                },
                product_info: productInfo,
            },
        });
    }, []);

    return { ubcSend };
}
